<template>
  <div
    class="table-item-content"
    title=" ">
    <span class="table-item-content-text">
      {{ props.row.datesFormations }}
    </span>
    <div v-if="props.row.fuseauHoraire">
      <span class="table-item-content-sub-text">
        {{ props.row.fuseauHoraire }}
      </span>
    </div>
    <div v-if="props.row.inProgress">
      <span class="table-item-content-sub-text text-in-progress">
        En cours
      </span>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { Formation } from '@/types/participant/formations-types';

  const props = withDefaults(
    defineProps<{
      row: Formation;
    }>(),
    {}
  );
</script>

<style lang="scss" scoped>
  .table-item-content {
    @apply flex flex-col;
    gap: 6px;

    .table-item-content-text {
      @apply flex-grow text-refonte-black;
      font-size: 14px;
      font-weight: 400;
      line-height: 125%;
    }

    .table-item-content-sub-text {
      @apply text-refonte-black-50;
      font-size: 12px;
      font-weight: 400;
      line-height: 120%;
    }

    .text-in-progress {
      @apply text-danger-500;
    }
  }
</style>
